import { RestaurantModal } from "./RestaurantModal";

export default RestaurantModal;
